module.exports = __webpack_public_path__ + "img/4bad919e2ba460940b3ac5f5a94394964303bb86.05fe5d64.png";